import axios from 'axios';
import { message } from 'ant-design-vue';
import { getLogo } from '@/utils/intConfiguration';

const baseURL = '/boss';

const omsMainServer = axios.create({
  timeout: 20000,
  baseURL,
});

/**
 * 添加 公共 headers
 * @returns Object
 */
const commonHeader = (config) => {
  let token = localStorage.getItem('token') || '';
  const appId = localStorage.getItem('appId') || '';
  function containsAny(inputString) {
    const keywords = [
      '/account/login',
      '/forget/password/sendVerifyCode',
      '/infra-authority/password/key',
      '/internet/user/login/domain',
      '/v1/license/app/info',
      '/internet/user/login/sms',
      '/internet/user/login/sendVerifyCode',
      '/intranet/user/login/code',
      '/forget/password/verify/mobilePhone',
      '/internet/user/login/pwd',
      '/internet/user/login/tps'];
    return keywords.some((keyword) => inputString.includes(keyword));
  }
  if (!containsAny(config.url) && !token) {
    // window.location.href = '/login';
  }
    // 登录时注销 token
    const urlSegments = [
      'login',
      'flyingBook',
      'openAgain',
      'middle',
      'saasLogin',
      'optimizeIndex',
      'push',
      'singleSignOn',
      'tps'
    ];

    if (containsAny(config.url) && urlSegments.some(segment => window.location.href.includes(segment))) {
      token = '';
    }
  return {
    'Content-Type': 'application/json; charset=UTF-8',
    'X-Auth-AppId': appId || getLogo().appId,
    'X-Auth-Token': token,
  };
};

/**
 * 请求头注入
 */
omsMainServer.interceptors.request.use((config) => {
  const baseConfig = { ...config };
  let curBaseURL = baseURL;
  if (process.env.NODE_ENV === 'development') {
    curBaseURL = baseURL;
    baseConfig.baseURL = curBaseURL;
  }
  baseConfig.headers = {
    ...commonHeader(baseConfig),
    ...baseConfig.headers,
  };
  return baseConfig;
});

const responseHandler = (response) => new Promise((resolve, reject) => {
  if (response && +response.status === 200) {
    const { errCode, data, message: resMessage = '' } = response.data;
    if (errCode) {
      if (errCode === 'L030030') {
        message.error('token过期，请重新登录');
        window.location.href = '/login';
        reject();
      } else if (errCode === 'L010721') {
        message.error('该用户已禁用');
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000);
      } else if (errCode === 'L030010') {
        message.error('抱歉，您没有权限');
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000);
      } else if (errCode === '0') {
        resolve(data);
      } else {
        if (resMessage) {
          message.error(resMessage);
        }
        reject();
      }
    } else {
      message.error('哎呀，系统异常，请联系管理员！');
      reject();
    }
  } else {
    message.error('哎呀，系统异常，请联系管理员！');
    reject();
  }
});

/**
 * get 请求
 * @param {String} url
 * @param {Object} params
 * @param {Object} options
 * @returns Promise
 */
const get = (url, params, options = {}) => omsMainServer({
  method: 'get',
  url,
  params,
  ...options,
}).then((res) => responseHandler(res));

/**
 * post 请求
 * @param {String} url
 * @param {Object} params
 * @param {Object} options
 * @returns Promise
 */
const post = (url, params, options = {}) => omsMainServer({
  method: 'post',
  url,
  data: params,
  ...options,
}).then((res) => responseHandler(res));

const http = { post, get };

export {
  http,
  post,
  get,
  omsMainServer,
};
